
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { ReactElement } from 'react'
import Title from '@jconradi/tutu-porn-components/components/Text/Title'
import HighlightedLink from '@jconradi/tutu-porn-components/components/Text/HighlightedLink'
import { getLayout } from '../components/Layout/Layout'

export default function Notice2257(){
    return(
        <section className="flex flex-col justify-center p-4 h-full w-full">
            <Title title="Tutu Porn 18 U.S.C 2257 Statement"/>
            <p className=''>
                All persons that appear in any visual depiction of actual sexually explicit conduct appearing or otherwise contained in this Website are required to be over the age of eighteen years at the time of the creation of such depictions.

                Various visual depictions displayed on this Website are exempt from the provision of 18 U.S.C. section 2257 and 28 C.F.R. 75 because said visual depictions do not consist of depictions of conduct as specifically listed in 18 U.S.C section 2256 (2) (A) through (D), but are merely depictions of non-sexually explicit nudity, or are depictions of simulated sexual conduct, or are otherwise exempt because the visual depictions were created prior to July 3rd, 1995.

                {`Tutu Porn is not the “producer” of the user-provided content found on tutuporn.com. Tutu Porns' activities in providing a point of display for such content are limited to the display, transmission, storage, retrieval, hosting and/or formatting of depictions posted by third party users, on areas of the website under the user's control. Records required by 18 U.S.C. § 2257 are held by the producer(s) of such content and requests for records should be directed to the producer(s).`}

                For further information, please contact Tutu support at <HighlightedLink href="/" text="support@tutu.porn"/>
            </p>
        </section>
    )
}

Notice2257.getLayout = (page: ReactElement) => getLayout(page)


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/notice2257',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  